import { sentryClient } from '../services/sentryClient';
import { getPromoteSubFramePath } from './getPromoteFramePath';

export function checkPostMessageSender(event: MessageEvent): boolean {
  try {
    const { data, origin } = event;

    if (!data) {
      return false;
    }

    const { promoteSubFrameNew, promoteSubFrameSrc } = getPromoteSubFramePath();

    return Boolean(
      origin &&
        (origin.includes(promoteSubFrameSrc) ||
          origin.includes(promoteSubFrameNew)),
    );
  } catch (error) {
    sentryClient.captureException(error);
    return false;
  }
}
